import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-label", "hollow", "variant"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../utils/filterProps';
import { getVariantTokens } from './StatusDot.helpers';
import { useVariantCssObject } from './StatusDot.hooks';
import { useMapTokenPropsToCSS } from '../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledStatusDot = styled.span.withConfig({
  displayName: "StatusDot__StyledStatusDot",
  componentId: "sc-1g1tidl-0"
})(props => {
  return Object.assign({}, props.$variantCssStyles, props.$cssStyles);
});
export function StatusDot(_ref) {
  let {
      'aria-label': ariaLabel,
      hollow = false,
      variant = 'neutral'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const variantTokens = getVariantTokens(variant);
  const variantCssStyles = useVariantCssObject(variantTokens, hollow);
  return /*#__PURE__*/_jsx(StyledStatusDot, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    $hollow: hollow,
    "aria-hidden": ariaLabel ? undefined : true,
    "aria-label": ariaLabel,
    $variantCssStyles: variantCssStyles
  }));
}